/**
 * The question types schema 1.0 defines.
 *
 * A leaf module with no imports on purpose: both the application and the build scripts that
 * generate the validators read this list, and anything heavier here would make the generator
 * depend on its own output.
 */
export const QUESTION_TYPES = [
  'single-choice',
  'multiple-choice',
  'matching',
  'ordering',
  'text',
] as const;

export type QuestionType = (typeof QUESTION_TYPES)[number];

export function isQuestionType(value: unknown): value is QuestionType {
  return typeof value === 'string' && (QUESTION_TYPES as readonly string[]).includes(value);
}
